import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarContainer,
  GridToolbarExport,
  ptBR,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { TextField, Autocomplete, Typography, Tooltip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { TrackersService } from "../../services/trackers";
import { NotificationManager } from "react-notifications";
import { Button } from 'antd';
import PublishRoundedIcon from '@mui/icons-material/PublishRounded';

export const DataGridTrackerOta = ({
  loadingData,
  data,
  columns,
  pageSize,
  rowsPerPageOptions,
  checkboxSelection,
  selectedRowsData,
  files,
  deviceIdSelected,
  idSelected,
  selectedRows
}) => {

  const trackerService = new TrackersService();
  const [rows, setRows] = useState(data);
  const [devices, setDevices] = useState([]);
  const [open, setOpen] = useState(false);
  const [idCancelDownload, setIdCancelDownload] = useState();
  const [disabledButton, setDisabledButton] = useState(false);


  useEffect(() => {
    if (data) {
      data.forEach((element2) => {
        element2.version = [];
        files.forEach((element1) => {
          element2.version.push(element1.version);
        });
      });
    }
    setRows(data);
  }, [data]);

  const columnSendPreset = [
    {
      field: 'sendPreset',
      headerName: "",
      width: 35,
      minWidth: 35,
      editable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Tooltip title={"Enviar Preset"} sx={{ height: '30px', width: '30px', color: 'rgb(15, 75, 116)', ':hover': { backgroundColor: 'rgb(193, 217, 245)' } }}>
            <GridActionsCellItem
              color="inherit"
              className="textPrimary"
              icon={< PublishRoundedIcon sx={{ fontSize: '26px', color: 'rgb(15, 75, 116)' }} />}
              label="Enviar Preset"
              onClick={() => handleSendPreset(params.row.deviceId)}

            />
          </Tooltip>
        );
      },
    }
  ]

  const firstConcat = columnSendPreset.concat(columns);
  const columnsWithActions = firstConcat.concat(
    {
      field: "search",
      headerName: (
        <Typography
          sx={{ fontSize: "14px", color: '#353535' }}
          component="div"
          align="center"
        >
          Arquivos hex
        </Typography>
      ),
      headerAlign: "center",
      editable: true,
      align: 'center',
      flex: 1.6,
      renderCell: (params) => {
        const options = Array.isArray(params.row.version)
          ? params.row.version
          : [];

        const versionByDeviceId = selectedRows.filter((row) => row.id === params.row.deviceId);

        const isDisabled = params.row.totalPage !== 0;

        return (
          <Tooltip title={isDisabled ? "Download em Andamento" : "Selecione uma Versão"} placement={'top'}><Autocomplete
            options={options}
            id={`combo-files-${params.row.id}`}
            size="small"
            sx={{ width: "100%", alignContent: 'center' }}
            renderInput={(params) => (
              <TextField {...params} label={!versionByDeviceId.length > 0 ? "Pesquisar Arquivos" : "Arquivo hex"} />
            )}
            onChange={(event, newValue) =>
              handleChangeValue(newValue, params.row.deviceId, params.row.id)
            }
            value={versionByDeviceId.length > 0 ? versionByDeviceId[0].version : ""}
            disabled={isDisabled}
          />
          </Tooltip>
        );
      },
    },
    {
      field: 'stopDownload',
      headerName: "",
      width: 35,
      minWidth: 35,
      editable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isDisabled = params.row.totalPage === 0;
        return (
          <Tooltip title={isDisabled ? "" : "Cancelar Download"}>
            <GridActionsCellItem
              icon={< CancelRoundedIcon style={{ fontSize: '26px', color: isDisabled ? 'rgb(194, 194, 194)' : 'rgb(255, 28, 28)' }} />}
              label="Cancelar Download"
              disabled={isDisabled}
              onClick={() => handleSelectedDeviceId(params.row.deviceId)}

            />
          </Tooltip>
        );
      },
    }
  );

  const handleChangeValue = (newValue, deviceId, rowId) => {
    deviceIdSelected(newValue, rowId);
    selectedRowsData(deviceId, newValue);
  };

  const onDeviceSelectionHandler = (id) => {
    const selectedRows = id.map((id) => rows.find((row) => row.id === id));
    const deviceIds = selectedRows.map((row) => row.deviceId);
    setDevices(deviceIds);
  };

  const handleSelectedDeviceId = (deviceId) => {
    setIdCancelDownload(deviceId);
    setOpen(true);
  }

  const handleCancelDownloadFirmware = () => {
    setDisabledButton(true);
    trackerService.cancelUpdateFirmware(idCancelDownload).then(response => {
      setOpen(false);
      NotificationManager.success(`Download do rastreador ${idCancelDownload} Cancelado com Sucesso`, "Sucesso", 3000);
      setDisabledButton(false);
    }).then((error) => {
      console.error(error);
      setOpen(false);
      setDisabledButton(false);
    })
  }

  const handleSendPreset = (deviceId) => {
    const command = `$LPM,47,`

    const presetCommand = {
      "deviceId": deviceId,
      "command": command,
    }

    trackerService.sendPreset(presetCommand).then(response => {
      NotificationManager.success(`Preset enviado com sucesso para o rastreador ${deviceId}`, "Sucesso", 3000);
    }).catch((error) => {
      console.error(error);
      NotificationManager.error(`Erro ao enviar preset para o rastreador ${deviceId}`, "Erro", 3000);
    })
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton sx={{ color: "#414141" }} size="20px" />
        <GridToolbarFilterButton sx={{ color: "#414141" }} size="20px" />
        <GridToolbarExport sx={{ color: "#414141" }} size="20px" />
      </GridToolbarContainer>
    );
  }

  const configComponentsProps = {
    panel: {
      sx: {
        "& .MuiTypography-root": {
          color: "#2f3237",
          fontSize: 12,
        },

        "& .MuiSvgIcon-root": {
          color: "#2f3237",
          marginTop: "-1px",
        },
        "& .batteryTrunk": {
          marginTop: "-1px",
          color: "#2f3237",
        },
        "& .svg-inline--fa": {
          marginTop: "-1px",
          color: "#2f3237",
        },
        "& .MuiDataGrid-columnsPanelRow:first-of-type": {
          display: "none",
        },
        "& .MuiDataGrid-panelFooter button:first-of-type": {
          display: "none",
        },
      },
    },
    footer: {
      sx: {
        "& .MuiTablePagination-root": {
          minHeight: "30px",
          height: "30px",
        },
        "& .MuiTablePagination-toolbar": {
          marginTop: "5px",
          minHeight: "10px",
          height: "10px",
        },
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
        {
          fontSize: "12px",
          margin: 0,
          color: "black !important",
        },
        "& .MuiTablePagination-select": {
          margin: 0,
          fontSize: "12px",
        },
        "& .MuiTablePagination-actions": {
          margin: 0,
        },
        "& .css-rtrcn9-MuiTablePagination-root:last-child": {
          display: "contents",
        },
      },
    },
  };

  return (
    <>
      <Box
        sx={{
          height: "60vh",
          width: "100%",
        }}
      >
        <DataGrid
          loading={loadingData}
          localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          components={{
            Toolbar: CustomToolbar,
          }}
          rows={rows}
          rowHeight={65}
          columns={columnsWithActions}
          pageSize={pageSize ?? 10}
          rowsPerPageOptions={rowsPerPageOptions ?? [5]}
          checkboxSelection={checkboxSelection}
          onSelectionModelChange={(id) => onDeviceSelectionHandler(id)}
          experimentalFeatures={{ newEditingApi: true }}
          disableRowSelectionOnClick={true}
          density='compact'
          componentsProps={configComponentsProps}
        />
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth={'sm'} fullWidth={true}>
        <DialogTitle>Cancelar Download</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja realmente cancelar o Download do Firmware?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: 6 }}>
          <Button type={"primary"} style={{ background: "#D21717", color: "white", fontSize: '14px', padding: 4, width: '80px' }} onClick={() => setOpen(false)}>Não</Button>
          <Button type={"primary"} style={{ background: "#008000", color: "white", fontSize: '14px', padding: 4, width: '80px' }} onClick={() => handleCancelDownloadFirmware()} loading={disabledButton} >Sim</Button>
        </DialogActions>
      </Dialog >
    </>
  );
};
